import type { TitledItemDto } from '@inference.engine/api-client';

/**
 * Key partners, marketing channels and customer-acquisition approaches arrive as a title
 * with a subtitle, but analyses generated before subtitles existed hold a bare string in
 * the same slot. Normalising here keeps every renderer on one shape.
 */
export const toTitledItem = (item: string | TitledItemDto): { title: string; subtitle?: string } =>
  typeof item === 'string' ? { title: item } : item;
